import React from "react";
import { ButtonDS, Typography } from "get-life-storybook-ts";
import {
  QuestionTreeErrorKindT,
  questionTreeErrorTexts,
  questionTreeRetryText,
} from "./questionTreeError";
import "./questionTreeError.scss";

interface QuestionTreeErrorPanelPropsI {
  kind: QuestionTreeErrorKindT;
  translate: (key: string) => string;
  /** Solo se ofrece en UNAVAILABLE (temporal): la versión no disponible no se arregla reintentando. */
  onRetry?: () => void;
  retrying?: boolean;
}

/**
 * Aviso en página cuando el monolito no puede servir el árbol de preguntas
 * (503 temporal o 502 de versión no disponible). Sustituye al navigate("/") que
 * acababa en bucle de redirecciones.
 */
const QuestionTreeErrorPanel = ({
  kind,
  translate,
  onRetry,
  retrying = false,
}: QuestionTreeErrorPanelPropsI) => {
  const { title, body } = questionTreeErrorTexts(translate, kind);
  const canRetry = "UNAVAILABLE" === kind && undefined !== onRetry;

  return (
    <div
      role="alert"
      data-testid="question-tree-error"
      data-kind={kind}
      className="questionTreeError"
    >
      <Typography text={title} variant="H3" weight="700" className="text-[#424242]" />
      <Typography text={body} variant="BodyMedium" weight="400" />
      {canRetry && (
        <ButtonDS
          label={questionTreeRetryText(translate)}
          onClick={onRetry}
          disabled={retrying}
          className="questionTreeError__retry"
        />
      )}
    </div>
  );
};

export default QuestionTreeErrorPanel;
